var exports = {
  "UD": "ApplicationsTab.module__buttonContainer___ZXUtQ2",
  "v$": "ApplicationsTab.module__documentationLink___ZXUtQ2",
  "Qp": "ApplicationsTab.module__documentationIcon___ZXUtQ2",
  "qI": "ApplicationsTab.module__listContainer___ZXUtQ2",
  "DB": "ApplicationsTab.module__itemContainer___ZXUtQ2",
  "k0": "ApplicationsTab.module__itemButton___ZXUtQ2",
  "HS": "ApplicationsTab.module__itemLeft___ZXUtQ2",
  "vi": "ApplicationsTab.module__itemAvatar___ZXUtQ2",
  "KO": "ApplicationsTab.module__itemAvatarPlaceholder___ZXUtQ2",
  "c2": "ApplicationsTab.module__itemTextBlock___ZXUtQ2",
  "wH": "ApplicationsTab.module__itemTitleRow___ZXUtQ2",
  "TJ": "ApplicationsTab.module__itemName___ZXUtQ2",
  "YD": "ApplicationsTab.module__itemMetaRow___ZXUtQ2",
  "v5": "ApplicationsTab.module__itemChevron___ZXUtQ2",
  "p$": "ApplicationsTab.module__emptyState___ZXUtQ2",
  "dc": "ApplicationsTab.module__spinnerContainer___ZXUtQ2",
};

module.exports = exports;
